import { State, Action, StateContext, Actions, ofActionSuccessful } from '@ngxs/store';
import { StoreState, StoreInfoUser, StoreToken, GetInfoUser, OpenOTP, SetDataOTP, SetTimeOTP, StoreTheme, StoreSourceInfos, GetAllResource, GetAllResourceLifeHero, CheckSummaryInsurance } from './app.actions';
import { Injectable } from '@angular/core';
import { Dispatcher } from './base/dispatcher';
import { UserService } from '../common/service/user.service';
import { UserProfile } from '../common/models/users.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NewOTPComponent } from '../common/components/otp/otp.component';
import { LocalStorageService } from 'ngx-webstorage';
import { EventManagerService } from '../common/service/event-manager.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppService } from './app.service';
declare let $: any;
export interface AppStateModel {
    states: any;
    userProfile: any;
    token: string;
    theme: any;
    sourceInfos: any;
    sourceLifeHero: any;
    otp: any;
    conRequestList: any;
    countingRequest: any
}

export function initAppState(): AppStateModel {
    return {
        userProfile: new UserProfile(),
        states: []
    } as AppStateModel;
}

@State<AppStateModel>({
    name: 'App',
    defaults: initAppState()
})
@Injectable()
export class AppState {
    callApi$ = new Subject();
    constructor(
        private actions$: Actions,
        private appService: AppService,
        private userService: UserService,
        private modalService: NgbModal,
        private localStorage$: LocalStorageService,
        public eventManger: EventManagerService,
    ) {
        this.callApi$.pipe(
            debounceTime(500),
            ).subscribe((event)=> { 
              this.getProfileUser(event);
            });
    }

    @Action(StoreState)
    StoreTag(ctx: StateContext<AppStateModel>, action: StoreState) {
        const states = action.payload;
        ctx.patchState({
            states
        });
    }
    @Action(StoreToken)
    StoreToken(ctx: StateContext<AppStateModel>, action: StoreToken) {
        const token = action.payload;
        ctx.patchState({
            token
        });
    }
    @Action(StoreTheme)
    StoreTheme(ctx: StateContext<AppStateModel>, action: StoreTheme) {
        const theme = action.payload;
        ctx.patchState({
            theme
        });
    }
    @Action(StoreSourceInfos)
    StoreSourceInfos(ctx: StateContext<AppStateModel>, action: StoreSourceInfos) {
        const sourceInfos = action.payload;
        ctx.patchState({
            sourceInfos
        });
    }
    @Action(StoreInfoUser)
    StoreInfoUser(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const userProfile = action.payload;
        ctx.patchState({
            userProfile
        });
    }
    @Action(GetInfoUser)
    GetInfoUser(ctx: StateContext<AppStateModel>, action: GetInfoUser) {
        const isFirst = action.payload;
        this.callApi$.next(isFirst);
    }
    @Action(GetAllResource)
    GetAllResource(ctx: StateContext<AppStateModel>, action: GetInfoUser) {
        return this.appService.getAllResource()
        .subscribe((res: any) => {
            ctx.patchState({
                sourceInfos: res.body.data
            });
        })
    }
    @Action(GetAllResourceLifeHero)
    GetAllResourceLifeHero(ctx: StateContext<AppStateModel>, action: GetInfoUser) {
        return this.appService.getAllLifeHero()
        .subscribe((res: any) => {
            const data = res.data || {};
            data.premiumBudgets = data.premiumTermRanges || [];
            data.premiumTerms = data.premiumTerms || [];
            data.assuredTerms = data.assuredTerms || [];
            data.paymentModes = (data.paymentModes || []).map((item) => {
                const keys = Object.keys(item);
                return {
                    code: keys[0],
                    name: item[keys[0]]
                }
            });
            data.insuranceNeeds = (data.insuranceNeeds || []).map((item) => {
                item.name = item.name.replace('(', '\n (');
                return item;
            });
            ctx.patchState({
                sourceLifeHero: data
            });
        })
    }
    getProfileUser(isFirst) {
        return this.userService.getProfileAPI(true, isFirst);
    }
    @Action(OpenOTP)
    OpenOTP(ctx: StateContext<AppStateModel>, action: OpenOTP) {
        const otp = Object.assign({}, ctx.getState().otp || {});
        const payload =  Object.assign({},action.payload || {});
        const user = this.localStorage$.retrieve('USER_PROFILE') || {};
        const options: NgbModalOptions = {
            backdrop : 'static',
            keyboard : false
        };
        options.centered = true;
        options.windowClass  = 'otp-order-label';
        const modalRef = this.modalService.open(NewOTPComponent, options);
        const properties = payload.isReopen ? otp : payload;
        modalRef.componentInstance.phone = payload.phone || user.phone;
        Object.keys(properties || {}).forEach((key) => {
            modalRef.componentInstance[key] = properties[key] || {};
        });
        if (!payload.isReopen) {
            Object.keys(properties || {}).forEach((key) => {
                otp[key] = properties[key] || {};
            });
            otp.startTime = Date.now();
            otp.failTimes = 0;
            modalRef.componentInstance.startTime = otp.startTime;
        }
        ctx.patchState({
            otp
        });
    }
    @Action(SetTimeOTP)
    SetTimeOTP(ctx: StateContext<AppStateModel>, action: SetTimeOTP) {
        const otp = Object.assign({}, ctx.getState().otp || {});
        const time = action.payload;
        otp.startTime = time;
        ctx.patchState({
            otp
        });
    }
    @Action(SetDataOTP)
    SetDataOTP(ctx: StateContext<AppStateModel>, action: SetDataOTP) {
        const otp = Object.assign({}, ctx.getState().otp || {});
        const payload = action.payload;
        Object.keys(payload).forEach((key) => {
            otp[key] = payload[key];
        });
        this.eventManger.broadcast({
            name: 'set-data-otp',
            content: {
                data: Object.assign({}, otp.data || {}),
                func: otp.func
            }
          })
        ctx.patchState({
            otp
        });
    }
    @Action(CheckSummaryInsurance)
    CheckSummaryInsurance(ctx: StateContext<AppStateModel>, action: CheckSummaryInsurance) {
        const isFocusNotice = action.payload;
        this.appService
        .loadSummaryConsultantRequest()
        .subscribe((res: any) => {
            if (!res) {
                return;
            }
            const countingRequest = res.data || {};
            ctx.patchState({
                countingRequest
            });
            if (countingRequest.notAssignedToAdvisor) {
                this.saveNotAssignedConsultantRequest(ctx, isFocusNotice);
            }
        });
    }
    saveNotAssignedConsultantRequest(ctx, isFocusNotice) {
        const body = {
            consultSteps: ['ASSIGNED_TO_ORG'],
            page: 1,
            size: 1000,
        };
        this.appService
        .queryConsultantRequest(body)
        .subscribe((res: any) => {
            if (!res) {
                return;
            }
            const list = res.data.list || [];
            let oldList = isFocusNotice ? [] : (ctx.getState().conRequestList || []).slice();
            ctx.patchState({
                conRequestList: list
            });
            if (!oldList.length && !isFocusNotice) {
                return;
            }
            const newItem = list.some(item => !oldList.some(oldItem => oldItem.id === item.id));
            if (newItem) {
                this.eventManger.broadcast({name: 'notice-has-not-assigned-consultant-request'});
            }

        });
    }
}
